import "./ShopPageBigCart.css";

import React from "react";
import { useEffect, useState } from "react";

import { Link } from "react-router-dom";

import TextField from "@mui/material/TextField";


export const ShopPageBigCart = ({
  subtotalValue,
  cartContent,
  handleUpdateCart,
  handleRemoveItem,
  changeNavBar,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleItemCountChange = (event) => {
    handleUpdateCart(event.target.id, event.target.value);
  };
  const removeFromCart = (event) => {
    handleRemoveItem(event.target.id);
  };

  
  const handleMoveToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    let href = window.location.href;
    let subHref = href.split("/")[3];
    if (subHref === "cart") {
      changeNavBar("isProducts", "rgba(41, 41, 41)", "white", "13rem", "row");
      
    }
  }, []);
  return (
    <div className="shop-page-bigCart-container">
      <div className="cart-title-section">
        <h1 className="cart-title">Количка</h1>
       
      </div>
      <div className="shop-page-bigCart-table-cellNames">
        <p className="shop-page-bigCart-table-cellNames-empty"></p>
        <p className="shop-page-bigCart-table-cellNames-product">Продукт</p>
        <p className="shop-page-bigCart-table-cellNames-price">Цена</p>
        <p className="shop-page-bigCart-table-cellNames-quantity">Количество</p>
        <p className="shop-page-bigCart-table-cellNames-total">Общо</p>
      </div>
      {cartContent.map((item) => {
        return (
          <div className="shop-page-bigCart-itemInstance-container">
            <div className="shop-page-bigCart-itemInstance-imgANDbutton-contaienr">
              <button
                id={item.name}
                onClick={removeFromCart}
                className="bigCart-remove-button"
              >
                X
              </button>
              <img
                className="shop-page-bigCart-itemInstance-img"
                src={item.imgSrc}
                alt="Loading"
              ></img>
            </div>

            <p className="shop-page-bigCart-itemInstance-name">{item.name}</p>
            <p className="shop-page-bigCart-itemInstance-price">
              {item.price}лв.
            </p>
            <div className="shop-page-bigCart-itemInstance-count">
              <TextField
                id={item.name}
                sx={{ width: "40%" }}
                onChange={handleItemCountChange}
                type="number"
                InputProps={{ inputProps: { min: 1 } }}
                defaultValue={item.count}
              ></TextField>
            </div>

            <p className="shop-page-bigCart-itemInstance-totalPrice">
              {(Number(item.count) * Math.round(item.price * 100)) / 100}лв.
            </p>
          </div>
        );
      })}

      <p className="shop-page-bigCart-table-totalPrice">
        Общо: {subtotalValue}лв.
      </p>
      <Link
        onClick={handleMoveToTop}
        to={"/checkout"}
        style={{
          opacity: isLoading === true ? "50%" : "100%",
          pointerEvents: isLoading === true ? "none" : "all",
        }}
        className="shop-page-bigCart-checkout-button"
      >
        Към поръчката
      </Link>
    </div>
  );
};
